import { Registry } from 'src/app/registry'
import applogger from '@applogger'
import debuglogger from 'src/debuglogger'
import { app } from './main'
import merge from 'lodash/merge'
import LogRocket from 'logrocket'
import chromeExtension from './chrome-extension'

import { defaultRegistry } from './default-registry'

const loadAppRegistry = () => {
  let registryPromise = null

  if (typeof siteConfig !== 'undefined' && window.Cypress === undefined) {
    if (process.env.NODE_ENV !== 'production') {
      console.debug('Loaded Registry from: window.siteConfig')
    }
    // eslint-disable-next-line no-undef
    registryPromise = Promise.resolve(siteConfig)
  }
  else {
    const currentTimestamp = Date.now()
    registryPromise = fetch('/dist/registry.json?' + currentTimestamp)
      .then((resp) => {
        if (resp.ok) {
          if (process.env.NODE_ENV !== 'production') {
            console.debug('Loaded Registry from: /dist.registy.json')
          }
          return resp.json()
        }
        else {
          throw new Error('Unable to load registry: /dist/registry.json')
        }
      })
      .catch((_err) => {
        return fetch('/dist/registry.js?' + currentTimestamp)
          .then((resp) => {
            if (resp.ok) {
              if (process.env.NODE_ENV !== 'production') {
                console.debug('Loaded Registry from: /dist/registy.js')
              }
              // eslint-disable-next-line no-eval
              return resp.text().then(registry => eval(registry))
            }
            else {
              throw new Error('Unable to load registry: /dist/registry.js')
            }
          })
      })
  }
  return registryPromise
    .then((registry) => {
      // if (typeof window.Cypress !== 'undefined') {
      // }
      const combinedRegistry = merge({}, defaultRegistry, registry)
      return combinedRegistry
    })
}

let appStarted = false
app.$ssrRunMode = false
app.$logRocket = LogRocket
loadAppRegistry()
  .then(config => {
    /* eslint-disable-next-line no-undef */
    const funcs = (typeof siteFuncs === 'undefined') ? {} : siteFuncs
    app.run(new Registry(config, funcs), false, window.location.protocol, window.location.host, window.location.port, window.location.origin, window.location.pathname)
      .then(appRun => {
        const router = appRun.router
        const store = appRun.store
        router.beforeResolve((to, from, next) => {
          if (!appStarted) {
            next()
          }
          applogger.debug(`beforeResolve called: ${to.fullPath}`)
          const matched = router.getMatchedComponents(to)
          // this is where we should trigger a loading indicator if there is one
          store.dispatch('showProgressLoader')
            .then(_ => app.loadAsyncData(matched, to))
            .then(_ => store.dispatch('hideProgressLoader'))
            .then(next)
            .catch(next)
        })

        router.onReady(() => {
          if (appStarted) {
            return
          }
          appStarted = true
          console.info('App Version: ' + process.env.BUILDVERSION)
          const matchedComponents = appRun.router.getMatchedComponents().filter(_ => _)
          // no matched routes, reject with 404
          // if (!matchedComponents.length) {
          //   store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
          // }

          app.loadAsyncData(matchedComponents)
            .then(_ => {
            // Communicate with the VinCreative Extension for Impersonate User Messages
              if (typeof chrome !== 'undefined') {
                chromeExtension({ store, app: appRun })
              }
              applogger.log('Mounting app.....')
              // Guarded directly, not just relying on debuglogger's internal
              // no-op - JSON.stringify(window.__INITIAL_STATE__) is real,
              // non-trivial work Terser can't prove is discarded just by
              // looking at the debuglogger.log(...) call site.
              //
              // NOTE this reflects the store as of THIS moment, after
              // app.loadAsyncData has resolved - by now the lite-catalogue
              // hydration fetch has already wholesale-replaced
              // state.products.products (window.__INITIAL_STATE__ is the
              // same object reference the store became reactive around, not
              // a clone, so it reflects that replacement too). For what SSR
              // actually shipped before any of that, see the earlier log in
              // vuejs-drupal-store/store/index.js, read at the point
              // window.__INITIAL_STATE__ is first consumed.
              if (process.env.DEBUG_LOGGING) {
                const initialStateSize = (typeof window.__INITIAL_STATE__ !== 'undefined') ? JSON.stringify(window.__INITIAL_STATE__).length : 0
                const productCount = (store.state.products && store.state.products.products) ? store.state.products.products.length : 0
                debuglogger.log(`[hydration] products in store: ${productCount}, initial state size: ${initialStateSize} bytes`)
              }
              return appRun.vueapp.$mount('#vuejs-app')
            })
            .catch(error => {
              applogger.log('Error resolving all components asyncData: ', error)
            })
        })
      })
  })
